import React from 'react';
import { useNewsletterIssues } from '../../hooks/useNewsletterIssues';
import { formatIssueDate } from '../../utils/newsletter';
export function NewsletterIssues() {
  const {
    issues,
    status
  } = useNewsletterIssues(2);

  // If the feed can't be reached, quietly fall back to the
  // "Read past issues" link below rather than showing an error.
  if (status === 'error') return null;
  return <div className="mb-10" data-id="element-146" data-mp="1ph1eovu4g11b">
      <h3 className="text-xl font-bold text-brand-navy mb-2" data-id="element-147" data-mp="1phuok5odn6no">Latest issues</h3>

      {status === 'loading' ? <ul aria-busy="true" aria-label="Loading latest issues" data-id="element-148" data-mp="1timwmvlij5id">
          {[0, 1].map(i => <li key={i} className="flex gap-5 py-6 border-b border-gray-100 animate-pulse" data-id="element-149" data-mp="1yfmwupvole1k">
              <div className="hidden sm:block w-28 h-20 rounded bg-brand-light-gray flex-shrink-0" data-id="element-150" data-mp="39wd6kizbcnzx" />
              <div className="flex-1 space-y-3" data-id="element-151" data-mp="3evhbgxf7fzkg">
                <div className="h-3 w-24 rounded bg-brand-light-gray" data-id="element-152" data-mp="3eu67oxlrertc" />
                <div className="h-5 w-3/4 rounded bg-brand-light-gray" data-id="element-153" data-mp="m6snaq41h824" />
                <div className="h-4 w-full rounded bg-brand-light-gray" data-id="element-154" data-mp="i4pd04t3w9if" />
              </div>
            </li>)}
        </ul> : <ul data-id="element-155" data-mp="d4jdk2glhips">
          {issues.map(issue => <li key={issue.link} className="border-b border-gray-100" data-id="element-156" data-mp="86hz5uu467kn">
              <a href={issue.link} target="_blank" rel="noopener noreferrer" className="group flex gap-5 py-6 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange rounded" data-id="element-157" data-mp="869mo41wl49z">
                {issue.thumbnail && <img src={issue.thumbnail} alt="" loading="lazy" className="hidden sm:block w-28 h-20 rounded object-cover flex-shrink-0 bg-brand-light-gray" data-id="element-158" data-mp="3qiei7gn7ljp6" />}
                <div className="min-w-0" data-id="element-159" data-mp="3bnrr01igvt5n">
                  {formatIssueDate(issue.pubDate) && <time dateTime={issue.pubDate} className="block text-sm text-brand-gray-light mb-1" data-id="element-160" data-mp="31y1d1tttcelu">
                      {formatIssueDate(issue.pubDate)}
                    </time>}
                  <span className="block text-lg font-bold text-brand-navy leading-snug group-hover:text-brand-orange transition-colors" data-id="element-161" data-mp="2wzrhvj839e08">
                    {issue.title}
                  </span>
                  {issue.excerpt && <span className="block mt-1 text-base text-brand-gray leading-relaxed" data-id="element-162" data-mp="3pof35esu83ds">
                      {issue.excerpt}
                    </span>}
                </div>
              </a>
            </li>)}
        </ul>}
    </div>;
}